// extracted by mini-css-extract-plugin
export var component = "WastePickupSearch-module--component--X8gHb";
export var form = "WastePickupSearch-module--form--wNAdI";
export var fieldset = "WastePickupSearch-module--fieldset--eSpZ1";
export var submitBtn = "WastePickupSearch-module--submitBtn--nFggw";
export var downloadButtonText = "WastePickupSearch-module--downloadButtonText--QKqkM";
export var submitBtnLongText = "WastePickupSearch-module--submitBtnLongText--PHpat";